"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: change signature to time com
const dateComparison = (a = null, b = null) => {
    const aTime = new Date(a).getTime();
    const bTime = new Date(b).getTime();
    if (aTime > bTime) {
        return 1;
    }
    if (bTime > aTime) {
        return -1;
    }
    return 0;
};
exports.default = dateComparison;
//# sourceMappingURL=dateComparison.js.map